import * as React from 'react';
const SvgIframe = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.28 7.53a.75.75 0 0 0-1.06-1.06l-2.5 2.5a.75.75 0 0 0 0 1.06l2.5 2.5a.75.75 0 0 0 1.06-1.06L5.31 9.5zM9.78 6.47a.75.75 0 0 0-1.06 1.06l1.97 1.97-1.97 1.97a.75.75 0 1 0 1.06 1.06l2.5-2.5a.75.75 0 0 0 0-1.06z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 0h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m0 1.5A1.5 1.5 0 0 0 1.5 3v.5h13V3A1.5 1.5 0 0 0 13 1.5zM1.5 13V5h13v8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 13"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIframe;
